export default {"src":"/_next/static/media/Edtech.db7d8f51.svg","height":44,"width":44};